import { useCollectionsLazyQuery } from '@generated/graphql/apollo';
import { useEffect, useState } from 'react';
import { useDidMount } from './useDidMount';
import { CollectionsQuery } from '@generated/graphql/types';
import { sortCollectionByPosition } from '@lib/utils';
export type CollectionNode = ArrayElementOf<
  NonNullable<CollectionsQuery['collections']>['edges']
>['node'];

export const useCollections: () => [
  Array<CollectionNode> | null,
  Array<CollectionNode> | null,
  {
    wasFetched: boolean;
    loading: boolean;
    refresh: () => Promise<void>;
  },
] = () => {
  // State if the collections have been fetched or at least has tried to been fetched.
  const [wasFetched, setWasFetched] = useState(false);
  const didMount = useDidMount();
  const [collectionsQuery, { data, error, refetch, loading }] = useCollectionsLazyQuery({
    variables: { first: 20 },
  });
  useEffect(() => {
    if (!didMount) {
      return;
    }
    if (!loading) {
      collectionsQuery();
    }
  }, [didMount]);

  useEffect(() => {
    if (!didMount) {
      return;
    }
    // On first load, wether we have collections or not, we set wasFetched to true.
    setWasFetched(true);
    if (error) {
      console.log('error while fetching collections', error);
    }
  }, [data, error]);

  const refresh = async () => {
    setWasFetched(false);
    await refetch();
    setWasFetched(true);
  };

  const collections: CollectionNode[] = data?.collections?.edges.map((edge) => edge.node) ?? [];
  const menuCollections = collections
    .filter((e) => e.includeInMenu?.value === '1')
    .sort((a, b) => sortCollectionByPosition(a, b));

  return [collections, menuCollections, { loading, refresh, wasFetched }];
};
